import {API_GMT_NUM, API_VCODE_GET, API_LOGIN, API_CY_UPDATE_NOTICE, API_CY_USER_INFO} from './api'
import request from './request'

/**
 * 查询用户信息
 */
export function getUserInfo () {
  return request(API_CY_USER_INFO, {
    method: 'GET'
  })
}

/**
 * 获取更新信息
 */
export function getUpdateNotice () {
  return request(API_CY_UPDATE_NOTICE, {
    method: 'GET'
  })
}

/**
 * 得到评论数据
 */
export function getGmtNum (cache, timestamp) {
  return request(API_GMT_NUM + `&cache=${cache}` + `&_=${timestamp}`, {
    method: "GET"
  })
}

/**
 * 获取验证码图片
 */
export function getVcode () {
  return request(API_VCODE_GET, {
    method: "GET"
  })
}

/**
 * 登录（新畅言 Go 后端 /api/admin/login，客服与站长统一入口）
 * @param values {name, password, vcode}
 * 成功时后端种 HttpOnly cookie（客服 cy_admin / 站长 KUAIZHAN_V2），
 * 响应为 {code: 0, data: {...}}；code!=0 时 msg 为错误文案。
 */
export function getLogin (values) {
  return request(API_LOGIN, {
    method: 'POST',
    json: { name: values.name, password: values.password, vcode: values.vcode },
    credentials: 'same-origin'
  })
}


